import { render } from "./ComponentNavBar.vue?vue&type=template&id=3b6b9346&scoped=true"
import script from "./ComponentNavBar.vue?vue&type=script&lang=js"
export * from "./ComponentNavBar.vue?vue&type=script&lang=js"

import "./ComponentNavBar.vue?vue&type=style&index=0&id=3b6b9346&scoped=true&lang=css"

import exportComponent from "/home/cospexa/cospexa.webservice/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b6b9346"]])

export default __exports__